<template>
    <el-popover :placement="placement" width="200" trigger="focus">
        <template>
            <div
                class="password-field-validation"
                :class="{ 'password-field-validation--passed': hasLength }"
            >
                <i class="password-field-icon fa" :class="hasLength ? 'fa-check' : 'fa-times'"></i>
                {{ $t('Longer than 6 characters') }}
            </div>
            <div
                class="password-field-validation"
                :class="{ 'password-field-validation--passed': hasUpperCase }"
            >
                <i
                    class="password-field-icon fa"
                    :class="hasUpperCase ? 'fa-check' : 'fa-times'"
                ></i>
                {{ $t('Has a capital letter') }}
            </div>
            <div
                class="password-field-validation"
                :class="{ 'password-field-validation--passed': hasLowerCase }"
            >
                <i
                    class="password-field-icon fa"
                    :class="hasLowerCase ? 'fa-check' : 'fa-times'"
                ></i>
                {{ $t('Has a lowercase letter') }}
            </div>
            <div
                class="password-field-validation"
                :class="{ 'password-field-validation--passed': hasNumber }"
            >
                <i class="password-field-icon fa" :class="hasNumber ? 'fa-check' : 'fa-times'"></i>
                {{ $t('Has a number') }}
            </div>
            <div
                class="password-field-validation"
                :class="{ 'password-field-validation--passed': hasSpecial }"
            >
                <i class="password-field-icon fa" :class="hasSpecial ? 'fa-check' : 'fa-times'"></i>
                {{ $t('Has a special character') }}
            </div>
        </template>
        <el-input
            slot="reference"
            v-model="fieldValue"
            :placeholder="placeholder"
            type="password"
            autocomplete="new-password"
            :size="size"
            :id="id"
            show-password
            @keyup.enter.native="onEnter"
        >
            <template v-if="showIcon" slot="prepend">
                <i class="fa fa-key"></i>
            </template>
        </el-input>
    </el-popover>
</template>

<script>
export default {
    name: 'passwordfield',
    props: {
        value: null,
        id: String,
        showIcon: {
            default() {
                return false;
            },
        },
        placement: {
            default() {
                return 'bottom';
            },
        },
        size: {
            default() {
                return 'medium';
            },
        },
        placeholder: {
            default() {
                return 'Password';
            },
        },
    },
    data() {
        return {
            fieldValue: this.$props.value,
            hasLength: false,
            hasNumber: false,
            hasLowerCase: false,
            hasUpperCase: false,
            hasSpecial: false,
        };
    },
    created() {
        this.passwordCheck();
    },
    watch: {
        value(value) {
            this.fieldValue = value;
        },
        fieldValue(value) {
            this.passwordCheck();
            this.$emit('input', value);
        },
    },
    methods: {
        passwordCheck() {
            this.hasLength = this.fieldValue && this.fieldValue.length > 6;
            this.hasNumber = this.fieldValue && /\d/.test(this.fieldValue);
            this.hasLowerCase = this.fieldValue && /[a-z]/.test(this.fieldValue);
            this.hasUpperCase = this.fieldValue && /[A-Z]/.test(this.fieldValue);
            this.hasSpecial = this.fieldValue && /[!@#\$%\^\&*\)\(+=._-]/.test(this.fieldValue); //eslint-disable-line
        },
        onEnter() {
            this.$emit('enter');
        },
        isValid() {
            return (
                this.hasLength &&
                this.hasNumber &&
                this.hasLowerCase &&
                this.hasUpperCase &&
                this.hasSpecial
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.password-field-validation {
    font-size: 11px;
    line-height: 15px;
}
.password-field-validation--passed {
    color: #717b85;
}
.password-field-icon {
    color: #eb0029;
}
.password-field-validation--passed .password-field-icon {
    color: #0fa140;
}
</style>
